export default __webpack_public_path__ + "static/media/imgDarkEn6.fb81e64f.png";